import React from 'react';
import { HeartIcon } from '@heroicons/react/24/outline';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 transition-colors duration-200 mt-auto">
      <div className="px-4 py-3">
        <div className="flex items-center justify-between text-sm text-gray-500 dark:text-gray-400">
          <div className="flex items-center space-x-1">
            <span>© {currentYear} Orchestra</span>
            <span>•</span>
            <span>AI Orchestration Platform</span>
          </div>
          
          <div className="flex items-center space-x-1">
            <span>Made with</span>
            <HeartIcon className="h-4 w-4 text-red-500" />
            <span>by the Orchestra Team</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 